export default __webpack_public_path__ + "static/media/pixelmon.fcb4cd7c.svg";